<template>
    <div>
        <!-- 声音设置 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title"
          >{{ $t("messageAdd.common.005") }}
        </span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{
          $t("message.systemMsg.MediaVolume")
        }}:</span>
        <el-input-number :min="0" :max="100" size="medium" v-model="v.m"></el-input-number>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{
          $t("message.systemMsg.ringerVolume")
        }}:</span>
        <el-input-number :min="0" :max="100" size="medium" v-model="v.r"></el-input-number>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{
          $t("message.systemMsg.AlarmVolume")
        }}:</span>
        <el-input-number :min="0" :max="100" size="medium" v-model="v.a"></el-input-number>
      </el-col>
    </el-row>
    </div>
</template>
<script>
export default {
  name: "DisplaySettings",
  props:{
    sound:{
      type:Object
    }
  },
  data() {
    return {
     
    };
  },
  computed:{
      v(){
      return this.sound
      }
    },
  watch:{
   // 监听 v 的变化，并通知父组件
   v: {
      handler(newVal) {
        this.$emit('update:sound', newVal);
        this.$emit('update:config-sound', newVal);

      },
      deep: true // 深度监听对象的变化
    }
  },
  methods: {},
}
</script>